import { GET_MOUVEMENTS_OR_CLIENT, DELETE_MOUVEMENT_OR_CLIENT } from '../actions/action-types';

const initialState = {
  liste: [],
  loadedAt: null
};

export default function mouvementsOrClientReducer(state = initialState, action) {
  switch (action.type) {
    case GET_MOUVEMENTS_OR_CLIENT:
      return { ...state, liste: action.payload, loadedAt: Date.now() };
    case DELETE_MOUVEMENT_OR_CLIENT:
      return { ...state, liste: state.liste.filter(m => m.id !== action.payload) };
    default:
      return state;
  }
}
